export default "__VITE_ASSET__4Q2Svbi3__"